import { all } from 'axios';
import { Chart,
    BarController, BarElement,
    LineController, LineElement, 
    PieController, ArcElement, DoughnutController,
    RadarController, RadialLinearScale,
    PointElement, Filler,
    CategoryScale, LinearScale, Title, Tooltip, Legend,
    scales
} from 'chart.js';

import { getChartLabelPlugin } from 'chart.js-plugin-labels-dv';
import { callback, color } from 'chart.js/helpers';
import { size } from 'lodash';
// Register the components you need
Chart.register(BarController, BarElement,
    LineController, LineElement, 
    PieController, ArcElement, DoughnutController,
    RadarController, RadialLinearScale,
    PointElement, Filler,
    CategoryScale, LinearScale,  Title, Tooltip, Legend,
    getChartLabelPlugin()
);

class Statistics {
    // Dean Statistics
    constructor() {
        this.trendAttendInst = null; // Initialize the chart instance as a property of the class 

        // Nexus General instances
        this.attBdInst = null;
        this.tsInst = null;

        // Nexus Statistics instances
        this.offensesBarChartInst = null;
        this.sanctionsBarChartInst = null;
        this.genderClassChartInst = null;
        this.trendChartInstance = null;
        this.incidentsPieChartInst = null;
        this.genderComparisonChartInst = null;  // Shared with Nexus General

        // this.attendanceBarChartInst = null;
        this.attendanceTrendChartInst = null;
    }

    static deanStatistics() {
        Generic.initCommonPageJS();
        Generic.initDeleteDialog();

        // Bar Charts
        var allDataColors = [
            '#ffa60080',
            '#ff7c4380',
            '#f95d6a80',
            '#d4508780',
            '#a0519580',
            '#66519180',
            '#2f4b7c80',
            '#003f5c80',
            '#006c7680',
            '#008f6880',
            '#9eaa1880',
            '#ffbc5d80',
            '#ffa27380',
            '#ff909280',
            '#e787ae80',
            '#c685bc80',
            '#9b85bc80',
            '#6f84af80',
            '#507e9a80',
            '#559ea780',
            '#008f6880',
            '#bcc16380',
        ];

        var allBorderColors = [
            '#ffa600',
            '#ff7c43',
            '#f95d6a',
            '#d45087',
            '#a05195',
            '#665191',
            '#2f4b7c',
            '#003f5c',
            '#006c76',
            '#008f68',
            '#9eaa18',
            '#ffbc5d',
            '#ffa273',
            '#ff9092',
            '#e787ae',
            '#c685bc',
            '#9b85bc',
            '#6f84af',
            '#507e9a',
            '#559ea7',
            '#008f68',
            '#bcc163',
        ];

        var specPeriod = window.specPeriod;

        // Offenses Bar Chart
        var offenseChart = document.getElementById('offenseChart').getContext('2d');
        var topOffensesJson = window.topOffensesJson;
        var offenses = Object.keys(topOffensesJson);
        var offensesData = Object.values(topOffensesJson);

        var offensesBarChart = new Chart(offenseChart, {
            type: 'bar',
            data: {
                labels: offenses,
                datasets: [{
                    label: '',
                    data: offensesData,
                    backgroundColor: [
                        'rgba(255, 99, 132, 0.2)',
                        'rgba(54, 162, 235, 0.2)',
                        'rgba(255, 206, 86, 0.2)',
                        'rgba(75, 192, 192, 0.2)',
                        'rgba(153, 102, 255, 0.2)',
                        'rgba(255, 159, 64, 0.2)'
                    ],
                    borderColor: [
                        'rgba(255, 99, 132, 1)',
                        'rgba(54, 162, 235, 1)',
                        'rgba(255, 206, 86, 1)',
                        'rgba(75, 192, 192, 1)',
                        'rgba(153, 102, 255, 1)',
                        'rgba(255, 159, 64, 1)'
                    ],
                    borderWidth: 1
                }]
            },
            options: {
                plugins: {
                    legend: {
                        display: false // Disable the legend
                    }
                },
                scales: {
                    y: {
                        beginAtZero: true,
                        ticks: {
                            precision: 0, // Ensures whole numbers
                            stepSize: 1 // Minimum step size set to 1
                        }
                    }
                }
            }
        });

        // Sanctions Bar Chart
        var sanctionChart = document.getElementById('sanctionChart').getContext('2d');
        var sanctionsJson = window.sanctionsJson;
        var sanctions = Object.keys(sanctionsJson);
        var sanctionsData = Object.values(sanctionsJson);

        var sanctionsBarChart = new Chart(sanctionChart, {
            type: 'bar',
            data: {
                labels: sanctions,
                datasets: [{
                    label: '',
                    data: sanctionsData,
                    backgroundColor: 'rgba(75, 192, 192, 0.2)',
                    borderColor: 'rgba(75, 192, 192, 1)',
                    borderWidth: 1
                }]
            },
            options: {
                plugins: {
                    legend: {
                        display: false // Disable the legend
                    }
                },
                scales: {
                    y: {
                        beginAtZero: true,
                        ticks: {
                            precision: 0, // Ensures whole numbers
                            stepSize: 1 // Minimum step size set to 1
                        }
                    }
                }
            }
        });
    
        // Line Graph
        // Chart of Sanctions by Gender and Class
        var gcChart = document.getElementById('genderClassChart').getContext('2d');
        var femaleJson = window.femaleJson;
        var gcLabels = Object.keys(femaleJson);
        var femaleData = Object.values(femaleJson);

        var maleJson = window.maleJson;
        var maleData = Object.values(maleJson);

        var gcConfig = {
            type: 'line',
            data: {
                labels: gcLabels,
                datasets: [{
                    label: 'Male',
                    data: maleData,
                    backgroundColor: "rgb(54, 162, 235, 0.2)",
                    borderColor: "rgb(54, 162, 235)",
                    fill: true,
                    pointRadius: 6,
                    pointHoverRadius: 20,
                    tension: 0.4
                }, {
                    label: 'Female',
                    data: femaleData,
                    backgroundColor: "rgb(255, 99, 132, 0.2)",
                    borderColor: "rgb(255, 99, 132)",
                    fill: true,
                    pointRadius: 6,
                    pointHoverRadius: 20,
                    tension: 0.4
                }]
            },options: {
                responsive: true,
                legend: {
                    position: 'top',
                },
                hover: {
                    mode: 'index'
                },
                scales: {
                    x: {
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Class'
                        }
                    },
                    y: {
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Incidents'
                        },
                        beginAtZero: true,
                        ticks: {
                            precision: 0, // Ensures whole numbers
                            stepSize: 1 // Minimum step size set to 1
                        }
                    }
                },
                title: {
                    display: false,
                    text: specPeriod+' incidents breakdown'
                }
            }
        };
        
        new Chart(gcChart, gcConfig);

        // Chart of Attendance Trends
        var attendData = attendJson;
        var attendLabels = Object.values(attendData['all_dates']);
        this.setAttendanceChart('all', attendLabels, attendData, allDataColors, allBorderColors);
        
        // this.setAttendanceChart('class', attendLabels, attendData, allDataColors, allBorderColors);
        $('.select-trend-type').on('click', function (e) {
            let curEl = e.currentTarget;
            let type = $(curEl).data('pk');
            if(!$(curEl).hasClass('active')){
                Statistics.setAttendanceChart(type, attendLabels, attendData, allDataColors, allBorderColors);
                $('.select-trend-type').removeClass('active');
                $(curEl).addClass('active');
                $('.sel-att-filter').text('('+$(curEl).text()+')');
            }
        });

        var trendChartInstance;

        $('#incident_entry').on('click', function (e) {
            let val = $('select[name="incident"]').val();
            console.log('select: '+val);
            let postUrl = specStatUrl+'?incident_data='+val;

            // var postData = {};
            // postData['incident_data'] = val;

            Generic.loaderStart();
            axios.post(postUrl)
                .then((response) => {
                    // console.log(response);
                    if (response.data.success) {
                        toastr.success(response.data.message);
                        console.log(response.data);

                        // Line Graph
                        // The Incident trend over a timeline
                        if (trendChartInstance) {
                            trendChartInstance.destroy();
                        }

                        var trendCanvas = document.getElementById('incidentTrendChart');
                        trendCanvas.style.width = '821px';
                        trendCanvas.style.height = '200px';
                        trendCanvas.width = 821;
                        trendCanvas.height = 200;
                        
                        var trendChart = trendCanvas.getContext('2d');
                        var chartIncident = response.data.incident;
                        var trendLabels = response.data.all_dates;
                        var trendData = response.data.incident_stats;
                        // const maxDataValue = Math.max(trendData);
                        // const autoStepSize = Math.ceil(maxDataValue / 10);

                        console.log('All trend chart data');
                        console.log(trendChart);
                        console.log(chartIncident);
                        console.log(trendLabels);
                        console.log(trendData);

                        var trendConfig = {
                            type: 'line',
                            data: {
                                labels: trendLabels,
                                datasets: [{
                                    label: chartIncident,
                                    data: trendData,
                                    backgroundColor: "rgb(236, 126, 255, 0.2)",
                                    borderColor: "rgb(236, 126, 255)",
                                    fill: false,
                                    pointRadius: 5,
                                    pointHoverRadius: 20,
                                    tension: 0
                                }]
                            },options: {
                                responsive: true,
                                legend: {
                                    position: 'top',
                                },
                                hover: {
                                    mode: 'index'
                                },
                                scales: {
                                    x: {
                                        display: true,
                                        scaleLabel: {
                                            display: true,
                                            labelString: 'Date'
                                        }
                                    },
                                    y: {
                                        display: true,
                                        scaleLabel: {
                                            display: true,
                                            labelString: 'Instances'
                                        },
                                        beginAtZero: true,
                                        // stepSize: autoStepSize > 1 ? autoStepSize : 1
                                        ticks: {
                                            precision: 0, // Ensures whole numbers
                                            stepSize: 1 // Minimum step size set to 1
                                        }
                                    }
                                },
                                title: {
                                    display: false,
                                    text: specPeriod+': '+chartIncident+' trend'
                                }
                            }
                        };
                        
                        console.log('All trend chart config');
                        console.log(trendConfig);
                        
                        trendChartInstance = new Chart(trendChart, trendConfig);
                    } else {
                        let status = response.data.message;
                        toastr.error(status);
                    }
                    Generic.loaderStop();
                }).catch((error) => {
                    // console.log(error.response);
                    let status = error;
                    // let status = error.response.statusText;
                    toastr.error(status);
                    Generic.loaderStop();
                });

            $('.sel-inc-text').text('('+val+')');
        });

        // All Incidents Pie Chart
        var allIncidentsChart = document.getElementById('allIncidentsChart').getContext('2d');
        var incidentsJson = window.incidentsJson;
        var allIncidentLabels = Object.keys(incidentsJson);
        var allIncidentData = Object.values(incidentsJson);

        if (this.isAllZero(allIncidentData)) {
            // console.log('all zero');
            // Assign a very small values
            allIncidentData = allIncidentData.map(() => 1e-10);
            console.log(allIncidentData);
        }

        var incidentsPieChart = new Chart(allIncidentsChart, {
            type: 'pie',
            data: {
                labels: allIncidentLabels,
                datasets: [{
                    // label: '',
                    data: allIncidentData,
                    backgroundColor: allDataColors,
                    borderColor: allBorderColors,
                    borderWidth: 1
                }]
            },
            options: {
                layout: {
                    padding: {
                        top: 20,
                        bottom: 20,
                        left: 20,
                        right: 20
                    }
                },
                plugins: {
                    legend: {
                        display: false // Disable the legend
                    },
                    labels: [
                        {
                            render: 'label',
                            position: 'outside',
                            arc: true,
                            overlap: false,
                            padding: 10
                        },{ 
                            render: function(args) {
                                var percentage = (args.value / args.dataset.data.reduce((a, b) => a + b, 0)) * 100;
                                percentage = percentage.toFixed(0);
                                if (percentage < 4) {
                                    return '';
                                } else {
                                    return `${percentage}%`;
                                }
                            },
                        }
                    ]
                },
                responsive: true
            }
        });

        // Gender Comparison Doughnut Chart
        var genderComparisonChart = document.getElementById('genderComparisonChart').getContext('2d');
        var genderComparisonData = [window.allFemale, window.allMale];

        console.log(genderComparisonData);
        if (this.isAllZero(genderComparisonData)) {
            console.log('all zero');
            // Assign a very small values
            genderComparisonData = genderComparisonData.map(() => 1e-10);
        }

        var genderComparisonDoughnutChart = new Chart(genderComparisonChart, {
            type: 'doughnut',
            data: {
                labels: ['Female', 'Male'],
                datasets: [{
                    // label: '',
                    data: genderComparisonData,
                    backgroundColor: ["rgb(255, 99, 132, 0.5)", "rgb(54, 162, 235, 0.5)"],
                    borderColor: ["rgb(255, 99, 132)", "rgb(54, 162, 235)"],
                    borderWidth: 1
                }]
            },
            options: {
                responsive: true,
                plugins: { labels: [{ 
                    render: function(args) {
                        var percentage = (args.value / args.dataset.data.reduce((a, b) => a + b, 0)) * 100;
                        percentage = percentage.toFixed(0);
                        if (percentage < 4) {
                            return '';
                        } else {
                            return `${percentage}%`;
                        }
                    },
                }] },
            }
        });
    }

    static setAttendanceChart(type, labels, data, bgColors, borderColors) {
        console.log(type);
        console.log(data);

        if(type === 'all'){
            var readyData = Object.values(data['num_attend']['all']);
            var attendDatasets = [
                {
                    label: 'All',
                    data: readyData,
                    backgroundColor: bgColors[0],
                    borderColor: borderColors[0],
                    fill: true,
                    pointRadius: 6,
                    pointHoverRadius: 20,
                    tension: 0.4
                }
            ];
        }else{
            var dataKeys = Object.keys(data['num_attend'][type]);
            attendDatasets = [];
            dataKeys.forEach((each, index) => {
                var curData = Object.values(data['num_attend'][type][each]);
                var colIndex = index;
                if(index > 20){
                    colIndex = index % 20;
                }
                let bgHue = bgColors[index];
                let borderHue = borderColors[index];
                if(each === 'Male'){
                    bgHue = 'rgb(54, 162, 235, 0.2)';
                    borderHue = 'rgb(54, 162, 235)';
                }else if(each === 'Female'){
                    bgHue = 'rgb(255, 99, 132, 0.2)';
                    borderHue = 'rgb(255, 99, 132)';
                }
                attendDatasets.push(
                    {
                        label: each,
                        data: curData,
                        backgroundColor: bgHue,
                        borderColor: borderHue,
                        fill: true,
                        pointRadius: 5,
                        pointHoverRadius: 15,
                        tension: 0.4
                    }
                );
            });
            console.log('Data - Class');
            console.log(data['num_attend']['class']);
        }


        var attendChartConfig = {
            type: 'line',
            data: {
                labels: labels,
                datasets: attendDatasets
            },options: {
                responsive: true,
                legend: {
                    position: 'top',
                },
                hover: {
                    mode: 'index'
                },
                scales: {
                    x: {
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Dates'
                        }
                    },
                    y: {
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Number'
                        },
                        beginAtZero: true,
                        ticks: {
                            precision: 0, // Ensures whole numbers
                            stepSize: 1 // Minimum step size set to 1
                        }
                    }
                },
                title: {
                    display: false,
                    text: specPeriod+' attendances'
                }
            }
        };
        if(this.trendAttendInst) {
            console.log('destroyed?');
            this.trendAttendInst.destroy();
        }

        var attendCanvas = document.getElementById('attendanceTrendChart');
        attendCanvas.style.width = '821px';
        attendCanvas.style.height = '200px';
        attendCanvas.width = 821;
        attendCanvas.height = 200;
        
        var attendChart = attendCanvas.getContext('2d');
        
        this.trendAttendInst = new Chart(attendChart, attendChartConfig);

        return true;
    }

    static isAllZero(data) {
        return data.every(value => value === 0);
    }
    static randBetween(min, max) {
        // returns between min and max-1
        return Math.floor(Math.random() * (max - min)) + min;
    }
    static createOrUpdateChart(canvas, chartInst, chartData, config) { 
        if(chartInst){ 
            // If the chart instance already exists, update its data and options. 
            chartInst.data = chartData;
            chartInst.update();
        }else{ 
            // Create a new chart instance if it doesn't exist. 
            config.data = chartData;
            chartInst = new Chart(canvas, config); 
        }
        return chartInst;
    }

    static nexusGeneral() {
        Generic.initCommonPageJS();
        
        var generalColors = [
            '#37eba0',
            '#00e3be',
            '#00d6d4',
            '#00c9e5',
            '#00bbf6',
            '#00a9ff',
            '#4b94ff',
            '#747cff',
            '#9659ff',
            '#b619ff',
        ];
        
        // Gender Comparison - Radar Chart
        var genderComparisonChart = document.getElementById('demoGraphCanvas').getContext('2d');
        var genderComparisonLabels = Object.keys(studentsData['Male']);
        var maleComparisonData = Object.values(studentsData['Male']);
        var femaleComparisonData = Object.values(studentsData['Female']);
        var allComparisonData = maleComparisonData.map((value, index) => value + femaleComparisonData[index]);

        const genderCompConfig = {
            type: 'bar',
            data: null,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    title: {
                        display: false,
                        text: 'Demographics by Grades'
                    },
                    legend: {
                        position: 'top',
                        display: true,
                        labels: { 
                            color: '#bbb' 
                        }
                    }
                },
                scales: {
                    x: {
                        display: true,
                        grid: { 
                            color: '#777' 
                        },
                        ticks: { 
                            color: '#bbb',
                            callback: function(value) { 
                                // console.log('X ticks:');
                                // console.log(this.getLabelForValue(value));
                                return 'Grade ' + this.getLabelForValue(value);
                            }
                        },
                        scaleLabel: {
                            display: false,
                            labelString: 'Grade'
                        }
                    },
                    y: {
                        display: true,
                        scaleLabel: {
                            display: false,
                            labelString: 'Number of Students'
                        },
                        beginAtZero: true,
                        grid: { 
                            color: '#777' 
                        },
                        ticks: {
                            color: '#bbb',
                            precision: 0, // Ensures whole numbers
                        }
                    }
                }
            },
        };

        const genderCompConfigData = {
            labels: genderComparisonLabels,
            datasets: [
                {
                    label: 'All',
                    data: allComparisonData,
                    borderColor: generalColors[0],
                    backgroundColor: generalColors[0],
                    order: 1,
                    barPercentage: 0.6
                },
                {
                    label: 'Male',
                    data: maleComparisonData,
                    borderColor: 'rgb(54, 162, 235)',
                    backgroundColor: 'rgba(54, 162, 235, 0)',
                    type: 'line',
                    order: 0
                },
                {
                    label: 'Female',
                    data: femaleComparisonData,
                    borderColor: 'rgb(255, 99, 132)',
                    backgroundColor: 'rgba(255, 99, 132, 0)',
                    type: 'line',
                    order: 0
                }
            ]
        };

        this.genderComparisonChartInst = this.createOrUpdateChart(
            genderComparisonChart, 
            this.genderComparisonChartInst, 
            genderCompConfigData, 
            genderCompConfig
        );


        var tsChart = document.getElementById('tsCanvas').getContext('2d');
        var tsValues = [totalCount["students-count"], totalCount["teacher-count"]];
        if (this.isAllZero(tsValues)) {
            tsValues = tsValues.map(() => 1e-10);
        }

        const tsConfig = {
            type: 'doughnut',
            data: null,
            options: {
                maintainAspectRatio: false,
                layout: {
                    padding: {
                        top: 20,
                        bottom: 20,
                        left: 20,
                        right: 20
                    }
                },
                plugins: {
                    legend: {
                        display: false // Disable the legend
                    },
                    labels: [
                        {
                            render: 'label',
                            position: 'outside',
                            arc: true,
                            overlap: false,
                            padding: 10,
                            fontColor: '#bbb'
                        },{
                            render: function(args) {
                                var percentage = (args.value / args.dataset.data.reduce((a, b) => a + b, 0)) * 100;
                                percentage = percentage.toFixed(0);
                                if (percentage < 4) {
                                    return '';
                                } else {
                                    return `${percentage}%`;
                                }
                            },
                        }
                    ]
                },
                responsive: true
            }
        };
        const tsConfigData = {
            labels: ['Student', 'Teacher'],
            datasets: [
                {
                    data: tsValues,
                    borderColor: [generalColors[0], generalColors[generalColors.length - 1]],
                    backgroundColor: [generalColors[0]+'80', generalColors[generalColors.length - 1]+'80'],
                    borderWidth: 1
                }
            ]
        };

        this.tsInst = this.createOrUpdateChart(tsChart, this.tsInst, tsConfigData, tsConfig);
    }

    static nexusBehavioral() {
        Generic.initCommonPageJS();

        var allDataColors = [
            '#37eba080',
            '#00e3be80',
            '#00d6d480',
            '#00c9e580',
            '#00bbf680',
            '#00a9ff80',
            '#4b94ff80',
            '#747cff80',
            '#9659ff80',
            '#b619ff80'
        ];

        var allBorderColors = [
            '#37eba0',
            '#00e3be',
            '#00d6d4',
            '#00c9e5',
            '#00bbf6',
            '#00a9ff',
            '#4b94ff',
            '#747cff',
            '#9659ff',
            '#b619ff'
        ];

        var specPeriod = window.specPeriod;

        // Offenses Bar Chart
        var offenseChart = document.getElementById('offenseChart').getContext('2d');
        var topOffensesJson = window.topOffensesJson;
        var offenses = Object.keys(topOffensesJson);
        var offensesData = Object.values(topOffensesJson);

        var offensesBarConfig = {
            type: 'bar',
            data: null,
            options: {
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false // Disable the legend
                    }
                },
                scales: {
                    x:{
                        grid: { 
                            color: '#777' 
                        },
                        ticks: { 
                            color: '#bbb',
                        }
                    },
                    y: {
                        beginAtZero: true,
                        grid: { 
                            color: '#777' 
                        },
                        ticks: {
                            precision: 0, // Ensures whole numbers
                            stepSize: 1, // Minimum step size set to 1
                            color: '#bbb'
                        }
                    }
                }
            }
        };
        var offensesBarConfigData = {
            labels: offenses,
            datasets: [{
                label: '',
                data: offensesData,
                backgroundColor: allDataColors,
                borderColor: allBorderColors,
                borderWidth: 1
            }]
        };

        this.offensesBarChartInst = this.createOrUpdateChart(
            offenseChart, 
            this.offensesBarChartInst, 
            offensesBarConfigData, 
            offensesBarConfig
        );


        // Sanctions Bar Chart
        var sanctionChart = document.getElementById('sanctionChart').getContext('2d');
        var sanctionsJson = window.sanctionsJson;
        var sanctions = Object.keys(sanctionsJson);
        var sanctionsData = Object.values(sanctionsJson);

        var sanctionsConfigData = {
            labels: sanctions,
            datasets: [{
                label: '',
                data: sanctionsData,
                backgroundColor: [...allDataColors].reverse(),
                borderColor: [...allBorderColors].reverse(),
                borderWidth: 1
            }]
        };

        var sanctionsConfig = {
            type: 'bar',
            data: null,
            options: {
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false // Disable the legend
                    }
                },
                scales: {
                    x: {
                        beginAtZero: true,
                        grid: { 
                            color: '#777' 
                        },
                        ticks: {
                            color: '#bbb',
                        }
                    },
                    y: {
                        beginAtZero: true,
                        grid: { 
                            color: '#777' 
                        },
                        ticks: {
                            color: '#bbb',
                            precision: 0, // Ensures whole numbers
                            stepSize: 1 // Minimum step size set to 1
                        }
                    }
                }
            }
        };

        this.sanctionsBarChartInst = this.createOrUpdateChart(
            sanctionChart, 
            this.sanctionsBarChartInst, 
            sanctionsConfigData, 
            sanctionsConfig
        );
    
        // Line Graph
        // Chart of Sanctions by Gender and Class
        var gcChart = document.getElementById('genderClassChart').getContext('2d');
        var femaleJson = window.femaleJson;
        var gcLabels = Object.keys(femaleJson);
        var femaleData = Object.values(femaleJson);

        var maleJson = window.maleJson;
        var maleData = Object.values(maleJson);

        var gcConfig = {
            type: 'line',
            data: null,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    position: 'top',
                },
                hover: {
                    mode: 'index'
                },
                scales: {
                    x: {
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Class'
                        },
                        grid: { 
                            color: '#777' 
                        },
                        ticks: {
                            color: '#bbb',
                        }
                    },
                    y: {
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Incidents'
                        },
                        beginAtZero: true,
                        grid: { 
                            color: '#777' 
                        },
                        ticks: {
                            color: '#bbb',
                            precision: 0, // Ensures whole numbers
                            stepSize: 1 // Minimum step size set to 1
                        }
                    }
                },
                title: {
                    display: false,
                    text: specPeriod+' incidents breakdown'
                }
            }
        };

        var gcConfigData = {
            labels: gcLabels,
            datasets: [{
                label: 'Male',
                data: maleData,
                backgroundColor: "rgb(54, 162, 235, 0.2)",
                borderColor: "rgb(54, 162, 235)",
                fill: true,
                pointRadius: 6,
                pointHoverRadius: 20,
                tension: 0.4
            }, {
                label: 'Female',
                data: femaleData,
                backgroundColor: "rgb(255, 99, 132, 0.2)",
                borderColor: "rgb(255, 99, 132)",
                fill: true,
                pointRadius: 6,
                pointHoverRadius: 20,
                tension: 0.4
            }]
        }
        
        this.genderClassChartInst = this.createOrUpdateChart(gcChart, this.genderClassChartInst, gcConfigData, gcConfig);

        $('#incident_entry').on('click', () => {
            $('.incident-trend-cont').css('height', '300px');
            // $('.incident-trend-cont').css('max-height', '300px');
            
            let incidentSel = $('select[name="incident"]').val();
            let incidentSelTrend = incidentTrends[incidentSel];

            console.log('incidentTrends: ', incidentTrends);
            console.log('incidentSel: ', incidentSel);
            console.log('incidentSelTrend: ', incidentSelTrend);

            // Generic.loaderStart();
            if(incidentSelTrend){
                if(incidentSelTrend.success){
                    // Line Graph
                    // The Incident trend over a timeline

                    var trendChart = document.getElementById('incidentTrendChart').getContext('2d');

                    var chartIncident = incidentSelTrend.incident;
                    var trendLabels = incidentSelTrend.all_dates;
                    var trendData = incidentSelTrend.incident_stats;

                    console.log('All trend chart data');
                    console.log(trendChart);
                    console.log(chartIncident);
                    console.log(trendLabels);
                    console.log(trendData);
                    
                    // var bgRandIndex = Statistics.randBetween(0, allDataColors.length);
                    var colorRandIndex = Statistics.randBetween(0, allBorderColors.length);

                    var trendConfigData = {
                        labels: trendLabels,
                        datasets: [{
                            label: chartIncident,
                            data: trendData,
                            backgroundColor: allDataColors[colorRandIndex],
                            borderColor: allBorderColors[colorRandIndex],
                            fill: true,
                            pointRadius: 5,
                            pointHoverRadius: 20,
                            tension: 0.4
                        }]
                    };

                    if(this.trendChartInstance){
                        // this.trendChartInstance.destroy();
                        this.trendChartInstance.data = trendConfigData;
                        this.trendChartInstance.update();
                    }else{
                        var trendConfig = {
                            type: 'line',
                            data: trendConfigData,
                            options: {
                                responsive: true,
                                maintainAspectRatio: false,
                                legend: {
                                    position: 'top',
                                    labels: { 
                                        color: '#bbb' 
                                    }
                                },
                                hover: {
                                    mode: 'index'
                                },
                                scales: {
                                    x: {
                                        display: true,
                                        scaleLabel: {
                                            display: true,
                                            labelString: 'Date'
                                        },
                                        grid: { 
                                            color: '#777' 
                                        },
                                        ticks: { 
                                            color: '#bbb'
                                        },
                                    },
                                    y: {
                                        display: true,
                                        scaleLabel: {
                                            display: true,
                                            labelString: 'Instances'
                                        },
                                        grid: { 
                                            color: '#777' 
                                        },
                                        beginAtZero: true,
                                        ticks: {
                                            precision: 0, // Ensures whole numbers
                                            stepSize: 1, // Minimum step size set to 1
                                            color: '#bbb'
                                        }
                                    }
                                },
                                title: {
                                    display: false,
                                    text: specPeriod+': '+chartIncident+' trend'
                                }
                            }
                        };
                        
                        console.log('All trend chart config');
                        console.log(trendConfig);
                        
                        this.trendChartInstance = new Chart(trendChart, trendConfig);
                    }
                    // toastr.success(incidentSelTrend.message);
                }else{
                    toastr.error(incidentSelTrend.message);
                }
            } else {
                toastr.error('This data could not be found');
            }
            // Generic.loaderStop();
        });

        // All Incidents Pie Chart
        var allIncidentsChart = document.getElementById('allIncidentsChart').getContext('2d');
        var incidentsJson = window.incidentsJson;
        var allIncidentLabels = Object.keys(incidentsJson);
        var allIncidentData = Object.values(incidentsJson);

        if (this.isAllZero(allIncidentData)) {
            // console.log('all zero');
            // Assign a very small values
            allIncidentData = allIncidentData.map(() => 1e-10);
            console.log(allIncidentData);
        }

        var allIncidentConfigData = {
            labels: allIncidentLabels,
            datasets: [{
                // label: '',
                data: allIncidentData,
                backgroundColor: allDataColors,
                borderColor: allBorderColors,
                borderWidth: 1
            }]
        }
        var allIncidentConfig = {
            type: 'pie',
            data: null,
            options: {
                maintainAspectRatio: false,
                layout: {
                    padding: {
                        top: 20,
                        bottom: 20,
                        left: 20,
                        right: 20
                    }
                },
                plugins: {
                    legend: {
                        display: false // Disable the legend
                    },
                    labels: [
                        {
                            render: 'label',
                            position: 'outside',
                            arc: true,
                            overlap: false,
                            padding: 10,
                            fontColor: '#bbb'
                        },{
                            render: function(args) {
                                var percentage = (args.value / args.dataset.data.reduce((a, b) => a + b, 0)) * 100;
                                percentage = percentage.toFixed(0);
                                if (percentage < 4) {
                                    return '';
                                } else {
                                    return `${percentage}%`;
                                }
                            },
                        }
                    ]
                },
                responsive: true
            }
        };

        this.incidentsPieChartInst = this.createOrUpdateChart(
            allIncidentsChart, 
            this.incidentsPieChartInst, 
            allIncidentConfigData, 
            allIncidentConfig
        );

        // Gender Comparison Doughnut Chart
        var genderComparisonChart = document.getElementById('genderComparisonChart').getContext('2d');
        var genderComparisonData = [window.allFemale, window.allMale];

        // console.log(genderComparisonData);
        if (this.isAllZero(genderComparisonData)) {
            console.log('all zero');
            // Assign a very small values
            genderComparisonData = genderComparisonData.map(() => 1e-10);
        }

        var genderCompConfigData = {
            labels: ['Female', 'Male'],
            datasets: [{
                // label: '',
                data: genderComparisonData,
                backgroundColor: ["rgb(255, 99, 132, 0.75)", "rgb(54, 162, 235, 0.75)"],
                borderColor: ["rgb(255, 99, 132)", "rgb(54, 162, 235)"],
                borderWidth: 1
            }]
        };
        var genderCompConfig = {
            type: 'doughnut',
            data: null,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                layout: {
                    padding: {
                        top: 20,
                        bottom: 20,
                        left: 20,
                        right: 20
                    }
                },
                plugins: { 
                    legend: {
                        display: false,
                        labels: { 
                            color: '#bbb' 
                        }
                    },
                    labels: [
                        {
                            render: 'label',
                            position: 'outside',
                            arc: true,
                            overlap: false,
                            padding: 10,
                            fontColor: '#bbb'
                        },{ 
                            render: function(args) {
                                var percentage = (args.value / args.dataset.data.reduce((a, b) => a + b, 0)) * 100;
                                percentage = percentage.toFixed(0);
                                if (percentage < 4) {
                                    return '';
                                } else {
                                    return `${percentage}%`;
                                }
                            },
                        }
                    ] 
                },
            }
        };

        this.genderComparisonChartInst = this.createOrUpdateChart(
            genderComparisonChart, 
            this.genderComparisonChartInst, 
            genderCompConfigData, 
            genderCompConfig
        );
    }

    static nexusAttendance(processSub = null) {
        var generalColors = [
            '#37eba0',
            '#00e3be',
            '#00d6d4',
            '#00c9e5',
            '#00bbf6',
            '#00a9ff',
            '#4b94ff',
            '#747cff',
            '#9659ff',
            '#b619ff',
        ];

        // Attendance Breakdown - Horizontal Bar Chart
        var attrBreakdownChart = document.getElementById('attrCompCanvas').getContext('2d');

        var attrBdLabels = Object.keys(studentAttendData);
        var attrBdData = [];

        for (const key in studentAttendData) { 
            if (studentAttendData.hasOwnProperty(key)) {
                console.log('Key:', key, 'Value:', studentAttendData[key]); 
                
                var thisStatusData = Object.values(studentAttendData[key]).reduce((acc, current) => acc + current, 0);
                attrBdData.push(thisStatusData);
            }
        }

        const attrBreakdownConfig = {
            type: 'bar',
            data: null,
            options: {
                maintainAspectRatio: false,
                indexAxis: 'y',
                elements: {
                    bar: {
                        borderWidth: 2,
                    }
                },
                responsive: true,
                plugins: {
                    legend: {
                        display: false
                    },
                },
                scales: {
                    x: {
                        grid: { 
                            color: '#777' 
                        },
                        ticks: { 
                            color: '#bbb',
                            precision: 0
                        },
                    },
                    y: {
                        grid: { 
                            color: '#777' 
                        },
                        ticks: { 
                            color: '#bbb',
                        }
                    },
                },

                title: {
                    display: false,
                    text: 'Attendance Breakdown'
                }
            }
        };

        const attrBreakdownData = {
            labels: attrBdLabels,
            datasets: [
                {
                    label: 'Status',
                    data: attrBdData,
                    borderColor: ['rgb(55, 235, 160)','rgb(0, 187, 246)', 'rgb(255, 109, 109)'],
                    backgroundColor: ['rgb(55, 235, 160)','rgb(0, 187, 246)', 'rgb(255, 109, 109)'],
                }
            ]
        };

        this.attBdInst = this.createOrUpdateChart(
            attrBreakdownChart, 
            this.attBdInst, 
            attrBreakdownData, 
            attrBreakdownConfig
        );
        

        // Attendance Trend - Line Charts
        console.log('sub', processSub, ' -> line chart:');
        console.log(multiFilterAttendData);
        
        var attendData = multiFilterAttendData;
        var attendLabels = attendData['all_dates'] ? Object.values(attendData['all_dates']) : [];
        Statistics.setNexusAttendanceChart('all', attendLabels, attendData);

        $('.select-trend-type').on('click', function (e) {
            let curEl = e.currentTarget;
            if(!$(curEl).hasClass('active')){
                let type = $(curEl).data('pk');
                var attendData = multiFilterAttendData;
                var attendLabels = attendData['all_dates'] ? Object.values(attendData['all_dates']) : [];

                Statistics.setNexusAttendanceChart(type, attendLabels, attendData);
                $('.select-trend-type').removeClass('active');
                $(curEl).addClass('active');
            }
        });
    }

    static setNexusAttendanceChart(type, labels, data, bgColors = null, borderColors = null) {
        console.log(type);
        console.log(data);

        if(!borderColors){
            borderColors = [
                '#ffa600',
                '#ff7c43',
                '#f95d6a',
                '#d45087',
                '#a05195',
                '#665191',
                '#2f4b7c',
                '#003f5c',
                '#006c76',
                '#008f68',
                '#9eaa18',
                '#ffbc5d',
                '#ffa273',
                '#ff9092',
                '#e787ae',
                '#c685bc',
                '#9b85bc',
                '#6f84af',
                '#507e9a',
                '#559ea7',
                '#008f68',
                '#bcc163',
            ];
        }

        if(!bgColors){
            bgColors = [];
            borderColors.forEach((each) => {
                bgColors.push(each+'70');
            });
        }

        if(type === 'all'){
            var readyData = (data['num_attend'] && data['num_attend']['all']) 
                ? Object.values(data['num_attend']['all']) : [];
            var attendDatasets = [
                {
                    label: 'All',
                    data: readyData,
                    backgroundColor: bgColors[0],
                    borderColor: borderColors[0],
                    fill: true,
                    pointRadius: 6,
                    pointHoverRadius: 20,
                    tension: 0.4
                }
            ];
        }else{
            var dataKeys = (data['num_attend'] && data['num_attend'][type]) 
                ? Object.keys(data['num_attend'][type]) : [];
            attendDatasets = [];
            dataKeys.forEach((each, index) => {
                var curData = data['num_attend'][type][each] ? Object.values(data['num_attend'][type][each]) : [];
                var colIndex = index;
                if(index > 20){
                    colIndex = index % 20;
                }
                let bgHue = bgColors[index];
                let borderHue = borderColors[index];
                if(each === 'Male'){
                    bgHue = 'rgb(54, 162, 235, 0.2)';
                    borderHue = 'rgb(54, 162, 235)';
                }else if(each === 'Female'){
                    bgHue = 'rgb(255, 99, 132, 0.2)';
                    borderHue = 'rgb(255, 99, 132)';
                }
                attendDatasets.push(
                    {
                        label: each,
                        data: curData,
                        backgroundColor: bgHue,
                        borderColor: borderHue,
                        fill: true,
                        pointRadius: 5,
                        pointHoverRadius: 15,
                        tension: 0.4
                    }
                );
            });
            // console.log('Data - Class');
            // console.log(data['num_attend']['class']);
        }


        var attendChartData = {
            labels: labels,
            datasets: attendDatasets
        };
        
        if(this.attendanceTrendChartInst) {
            console.log('existing chart to update');
            this.attendanceTrendChartInst.data = attendChartData;
            this.attendanceTrendChartInst.update();

            return true
        }
        console.log('create new chart');

        var attendChartConfig = {
            type: 'line',
            data: attendChartData,
            options: {
                responsive: true,
                legend: {
                    position: 'top',
                },
                hover: {
                    mode: 'index'
                },
                scales: {
                    x: {
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Dates'
                        },
                        grid: { 
                            color: '#777' 
                        },
                        ticks: { 
                            color: '#bbb',
                        }
                    },
                    y: {
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Number'
                        },
                        grid: { 
                            color: '#777' 
                        },
                        beginAtZero: true,
                        ticks: {
                            precision: 0, // Ensures whole numbers
                            // stepSize: 1 // Minimum step size set to 1
                            color: '#bbb',
                        }
                    }
                },
                title: {
                    display: false,
                    text: specPeriod+' attendances'
                }
            }
        };

        // var attendCanvas = document.getElementById('attendanceTrendChart');
        var attendCanvas = document.getElementById('attrTrendCanvas');
        // attendCanvas.style.width = '821px';
        // attendCanvas.style.height = '200px';
        // attendCanvas.width = 821;
        // attendCanvas.height = 200;
        
        var attendChart = attendCanvas.getContext('2d');
        
        this.attendanceTrendChartInst = new Chart(attendChart, attendChartConfig);

        return true;
    }
}

// Attach to window object
window.Statistics = Statistics;

export default Statistics;